import { Language } from "@/Common/Models/Domain/Language";

import { isValidString } from "@/Utils/String";

export const isValidLanguage = (language: unknown): language is Language => {
  return isValidString(language) && Object.values(Language).includes(language as Language);
};

export const normalizeLanguage = (language: unknown): Language | undefined => {
  if (!isValidString(language)) return undefined;

  const normalizedLanguage = language.trim().toLowerCase().split(/[-_]/)[0];

  return isValidLanguage(normalizedLanguage) ? normalizedLanguage : undefined;
};

export const navigatorLang = normalizeLanguage(navigator.language) ?? Language.ENGLISH;
